import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LayoutIndex from '@/layout/layout-index.vue'
import HomeView from '../views/HomeView.vue'
import { RouteConstants } from '@/models/constant'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/admin/school-manage',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/page-login.vue'),
  },
  {
    path: '/admin',
    redirect: '/admin/school-manage',
    component: LayoutIndex,
    children: [
      {
        path: '/admin/school-manage',
        name: 'school-manage',
        component: () => import('@/views/school/school-manage.vue'),
        meta: {
          title: '学校管理',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
      },
      {
        path: '/admin/composition-manage',
        name: 'composition-manage',
        redirect: '/admin/composition-manage/config',
        meta: {
          title: '作文管理',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/composition-manage/config',
            name: 'composition-config',
            component: () => import('@/views/composition/composition-manage.vue'),
            meta: {
              title: '作文配置',
              parent: '/admin/composition-manage/config',
              showMenu: true,
            },
          },
          {
            path: '/admin/composition-manage/resource',
            name: 'composition-resource',
            component: () => import('@/views/composition-resource/composition-resource.vue'),
            meta: {
              title: '资源管理',
              parent: '/admin/composition-manage/resource',
              showMenu: true,
            },
          }
        ]
      },
      {
        path: '/admin/computing-power',
        name: 'computing-power',
        component: () => import('@/views/computing-power/page-index.vue'),
        meta: {
          title: '算力管理',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
      },
      {
        path: '/admin/platform-settings',
        name: 'platform-settings',
        redirect: '/admin/platform-settings/subject',
        meta: {
          title: '平台设置',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/platform-settings/subject',
            name: 'subject',
            component: () => import('@/views/platform-settings/subject/subject-settings.vue'),
            meta: {
              title: '学科设置',
              parent: '/admin/platform-settings/subject',
              showMenu: true,
            },
          },
          {
            path: '/admin/platform-settings/version',
            name: 'version',
            component: () => import('@/views/platform-settings/version/version-settings.vue'),
            meta: {
              title: '版本设置',
              parent: '/admin/platform-settings/version',
              showMenu: true,
            },
          },
          {
            path: '/admin/platform-settings/grade',
            name: 'grade',
            component: () => import('@/views/platform-settings/grade/grade-settings.vue'),
            meta: {
              title: '年级设置',
              parent: '/admin/platform-settings/grade',
              showMenu: true,
            },
          },
          {
            path: '/admin/platform-settings/unit',
            name: 'unit',
            component: () => import('@/views/platform-settings/unit/unit-settings.vue'),
            meta: {
              title: '单元设置',
              parent: '/admin/platform-settings/unit',
              showMenu: true,
            },
          },
          {
            path: '/admin/platform-settings/lesson',
            name: 'lesson',
            component: () => import('@/views/platform-settings/lesson/lesson-settings.vue'),
            meta: {
              title: '课时设置',
              parent: '/admin/platform-settings/lesson',
              showMenu: true,
            },
          },
          {
            path: '/admin/platform-settings/agreement',
            name: 'agreement',
            component: () => import('@/views/platform-settings/agreement/agreement-settings.vue'),
            meta: {
              title: '协议管理',
              parent: '/admin/platform-settings/agreement',
              showMenu: true,
            },
          },
        ],
      },
      {
        path: '/admin/course-review',
        name: 'course-review',
        redirect: '/admin/course-review/course',
        meta: {
          title: '课程审核',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/course-review/course',
            name: 'course',
            component: () => import('@/views/course-review/course/course-review.vue'),
            meta: {
              title: '课程审核',
              parent: '/admin/course-review/course',
              showMenu: true,
            },
          },
          {
            path: '/admin/course-review/course-platform',
            name: 'course-platform',
            component: () => import('@/views/course-review/platform/course-platform.vue'),
            meta: {
              title: '平台课程',
              parent: '/admin/course-review/course-platform',
              showMenu: true,
            },
          },
        ],
      },
      {
        path: '/admin/course-review/course/detail',
        name: 'course-detail',
        component: () => import('@/views/course-review/course/course-detail.vue'),
        meta: {
          title: '课程详情',
          parentActive: '/admin/course-review/course',
          parent: '/admin/course-review/course',
          showMenu: true,
        },
      },
      {
        path: '/admin/course-review/course-platform/detail',
        name: 'course-platform-detail',
        component: () => import('@/views/course-review/platform/platform-detail.vue'),
        meta: {
          title: '平台课程详情',
          parentActive: '/admin/course-review/course-platform',
          parent: '/admin/course-review/course-platform',
          showMenu: true,
        },
      },
      {
        path: '/admin/model-debug',
        name: 'model-debug',
        redirect: '/admin/model-debug/innovation-center',
        meta: {
          title: '模型调试',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/model-debug/innovation-center',
            name: 'innovation-center',
            component: () => import('@/views/model-debug/innovation-center/innovation-center.vue'),
            meta: {
              title: '创课中心',
              parent: '/admin/model-debug/innovation-center',
              showMenu: true,
            },
          },
          {
            path: '/admin/model-debug/student-performance-evaluation',
            name: 'student-performance-evaluation',
            component: () => import('@/views/model-debug/student-performance-evaluation/student-performance-evaluation.vue'),
            meta: {
              title: '学情评价',
              parent: '/admin/model-debug/student-performance-evaluation',
              showMenu: true,
            },
          },
          {
            path: '/admin/model-debug/homework-manage',
            name: 'homework-manage',
            component: () => import('@/views/model-debug/homework-manage/homework-manage.vue'),
            meta: {
              title: '作业管理',
              parent: '/admin/model-debug/homework-manage',
              showMenu: true,
            },
          },
          {
            path: '/admin/model-debug/prompt/list',
            name: 'prompt-list',
            component: () => import('@/views/model-debug/page-prompt/prompt-list.vue'),
            meta: {
              title: '系统提示词',
              parent: '/admin/model-debug/prompt/list',
              showMenu: true,
            },
          },
        ],
      },
      {
        path: '/admin/question-bank',
        name: 'question-bank',
        redirect: '/workbench/student-performance-evaluation/course-evaluation',
        meta: {
          title: '题库管理',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/question-bank/manage',
            name: 'question-bank-manage',
            component: () => import('@/views/question-bank/question-bank-manage/question-bank-manage.vue'),
            meta: {
              title: '题库管理',
              parent: '/admin/question-bank/manage',
              showMenu: true,
            },
          },
          {
            path: '/admin/question-bank/question-type',
            name: 'question-type',
            component: () => import('@/views/question-bank/question-type/question-type.vue'),
            meta: {
              title: '题型设置',
              parent: '/admin/question-bank/question-type',
              showMenu: true,
            },
          },
        ],
      },
      {
        path: '/admin/question-bank/manage/detail',
        name: 'question-detail',
        component: () => import('@/views/question-bank/question-bank-manage/modules/question-detail.vue'),
        meta: {
          title: '题库详情',
          parentActive: '/admin/question-bank/manage',
          parent: '/admin/question-bank/manage',
          showMenu: true,
        },
      },
      {
        path: '/admin/warning-config',
        name: 'warning-config',
        component: () => import('@/views/warning-config/page-index.vue'),
        meta: {
          title: '预警配置',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
      },
      {
        path: '/admin/device-manage',
        name: 'device-manage',
        component: () => import('@/views/device-manage/device-manage.vue'),
        meta: {
          title: '设备管理',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
      },
      {
        path: '/admin/system-settings',
        name: 'system-settings',
        redirect: '/admin/system-settings/system-user',
        meta: {
          title: '系统设置',
          parent: RouteConstants.ADMIN_ROOT_DIRECTORY,
          showMenu: true,
        },
        children: [
          {
            path: '/admin/system-settings/system-user',
            name: 'system-user',
            component: () => import('@/views/system-settings/user/system-user.vue'),
            meta: {
              title: '系统用户',
              parent: '/admin/system-settings/system-user',
              showMenu: true,
            },
          },
          {
            path: '/admin/system-settings/storage-manage',
            name: 'storage-manage',
            component: () => import('@/views/system-settings/storage/storages-manage.vue'),
            meta: {
              title: '存储管理',
              parent: '/admin/system-settings/storage-manage',
              showMenu: true,
            },
          },
          {
            path: '/admin/system-settings/log-manage',
            name: 'log-manage',
            component: () => import('@/views/system-settings/log/log-manage.vue'),
            meta: {
              title: '日志管理',
              parent: '/admin/system-settings/log-manage',
              showMenu: true,
            },
          },
          {
            path: '/admin/system-settings/permission-manage',
            name: 'permission-manage',
            component: () => import('@/views/system-settings/permission-manage/permission-manage.vue'),
            meta: {
              title: '权限管理',
              parent: '/admin/system-settings/permission-manage',
              showMenu: true,
            },
          },
        ],
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export function resetRouter() {
  const newRouter = router
  ;(router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
